import { render, staticRenderFns } from "./submission-tab-interests.vue?vue&type=template&id=b9572a7a&scoped=true&"
import script from "./submission-tab-interests.vue?vue&type=script&lang=ts&"
export * from "./submission-tab-interests.vue?vue&type=script&lang=ts&"
import style0 from "./submission-tab-interests.vue?vue&type=style&index=0&id=b9572a7a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9572a7a",
  null
  
)

export default component.exports